import { HISTORY_OPERATION_TYPE } from "@letsbit/malcolmlb";
import { defineMessages } from "react-intl";
export const scope = "components.HisotryAdvancedSearch";

export const messages = defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: "Búsqueda avanzada",
  },
  movementType: {
    id: `${scope}.movementType`,
    defaultMessage: "Tipo de movimiento",
  },
  selectMovementType: {
    id: `${scope}.selectMovementType`,
    defaultMessage: "Selecciona tipo de movimiento",
  },
  cardsToInclude: {
    id: `${scope}.cardsToInclude`,
    defaultMessage: "Tarjetas a incluir",
  },
  deposits: {
    id: `${scope}.deposits`,
    defaultMessage: "Depósitos",
  },
  withdraws: {
    id: `${scope}.withdraws`,
    defaultMessage: "Retiros",
  },
  swaps: {
    id: `${scope}.swaps`,
    defaultMessage: "Conversión",
  },
  retentions: {
    id: `${scope}.retentions`,
    defaultMessage: "Retenciones",
  },
  cardTransactions: {
    id: `${scope}.cardTransactions`,
    defaultMessage: "Movimientos tarjetas",
  },
  referrerPayout: {
    id: `${scope}.referrerPayout`,
    defaultMessage: "Pagos de referidos",
  },
  interestPayments: {
    id: `${scope}.interestPayments`,
    defaultMessage: "Pagos de intereses",
  },
  adjustment: {
    id: `${scope}.adjustment`,
    defaultMessage: "Ajustes",
  },
  reward: {
    id: `${scope}.reward`,
    defaultMessage: "Recompensa",
  },
  autoSwap: {
    id: `${scope}.autoSwap`,
    defaultMessage: "Auto conversión",
  },
  payment: {
    id: `${scope}.payment`,
    defaultMessage: "Pago",
  },
  dollarize: {
    id: `${scope}.dollarize`,
    defaultMessage: "Dolarizar",
  },
  selectCurrency: {
    id: `${scope}.selectCurrency`,
    defaultMessage: "Selecciona activos",
  },
  ars: {
    id: `${scope}.ars`,
    defaultMessage: "Pesos argentinos",
  },
  usd: {
    id: `${scope}.usd`,
    defaultMessage: "Dólares",
  },
  state: {
    id: `${scope}.state`,
    defaultMessage: "Estado",
  },
  approved: {
    id: `${scope}.approved`,
    defaultMessage: "Aprobado",
  },
  rejected: {
    id: `${scope}.rejected`,
    defaultMessage: "Rechazados",
  },
  withErrors: {
    id: `${scope}.withErrors`,
    defaultMessage: "Con errores",
  },
  pending: {
    id: `${scope}.pending`,
    defaultMessage: "Pendientes",
  },
  since: {
    id: `${scope}.since`,
    defaultMessage: "Desde",
  },
  until: {
    id: `${scope}.until`,
    defaultMessage: "Hasta",
  },
  chooseDate: {
    id: `${scope}.chooseDate`,
    defaultMessage: "Elige una fecha",
  },
  search: {
    id: `${scope}.search`,
    defaultMessage: "BUSCAR",
  },
  ok: {
    id: `${scope}.ok`,
    defaultMessage: "ACEPTAR",
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: "CANCELAR",
  },
  sendTitle: {
    id: `${scope}.sendTitle`,
    defaultMessage: "Monedas a visualizar",
  },
  cardsSelectorTitle: {
    id: `${scope}.cardsSelectorTitle`,
    defaultMessage: "Tarjetas a mostrar",
  },
  resumeButton: {
    id: `${scope}.resumeButton`,
    defaultMessage: "RESÚMENES MENSUALES",
  },
});

export const movementTypeOptions = [
  {
    id: HISTORY_OPERATION_TYPE.TRADE,
    description: messages.swaps,
  },
  {
    id: HISTORY_OPERATION_TYPE.DEPOSIT,
    description: messages.deposits,
  },
  {
    id: HISTORY_OPERATION_TYPE.WITHDRAW,
    description: messages.withdraws,
  },
  {
    id: HISTORY_OPERATION_TYPE.REFERRER_PAYOUT,
    description: messages.referrerPayout,
  },
  {
    id: HISTORY_OPERATION_TYPE.INTEREST_PAYMENT,
    description: messages.interestPayments,
  },
  {
    id: HISTORY_OPERATION_TYPE.CARD_TRANSACTIONS,
    description: messages.cardTransactions,
  },
  {
    id: HISTORY_OPERATION_TYPE.ADJUSTMENT,
    description: messages.adjustment,
  },
  {
    id: HISTORY_OPERATION_TYPE.REWARD,
    description: messages.reward,
  },
  {
    id: HISTORY_OPERATION_TYPE.AUTOSWAP,
    description: messages.autoSwap,
  },
  {
    id: HISTORY_OPERATION_TYPE.PAYMENT,
    description: messages.payment,
  },
  {
    id: HISTORY_OPERATION_TYPE.WITHHOLDING,
    description: messages.retentions,
  },
  {
    id: HISTORY_OPERATION_TYPE.DOLLARIZE,
    description: messages.dollarize,
  },
];
